/**
 * Rubato: Klaviyo's pop-up waits for the consent banner.
 *
 * Klaviyo decides its own timing, and it does not know the cookie banner exists. On a first
 * visit both arrive within seconds of each other and the customer is asked two questions at
 * once, one of them a legal one, with the newsletter sitting over it.
 *
 * Klaviyo has no trigger condition for "after the consent banner is gone", so the gate is
 * here. While the banner is on screen the document carries data-rubato-consent-pending and
 * assets/rubato.css hides Klaviyo's form; when the banner goes, the attribute goes and
 * whatever Klaviyo has already rendered appears. Nothing is delayed that Klaviyo did not
 * already decide to show, and no Klaviyo setting is overridden: this only ever holds it back.
 *
 * Round 61 part 15.
 */

const BANNER = '#shopify-pc__banner';
const FLAG = 'data-rubato-consent-pending';

function bannerIsUp() {
  const banner = document.querySelector(BANNER);
  if (!banner) return false;
  const style = getComputedStyle(banner);
  if (style.display === 'none' || style.visibility === 'hidden') return false;
  return banner.getBoundingClientRect().height > 0;
}

function sync() {
  if (bannerIsUp()) {
    document.documentElement.setAttribute(FLAG, '');
  } else {
    document.documentElement.removeAttribute(FLAG);
  }
}

sync();

/* The banner is injected by Shopify after the document is parsed and removed when it is
   answered, so both edges are watched rather than polled. */
new MutationObserver(sync).observe(document.documentElement, { childList: true, subtree: true });

/* Answering the banner hides it without removing it in some of Shopify's paths, and a
   mutation on an attribute of a node deep in the tree is not always seen. A few cheap checks
   after the usual moments cover that without a timer running for the life of the page. */
for (const event of ['click', 'pageshow', 'visibilitychange']) {
  window.addEventListener(event, () => {
    sync();
    setTimeout(sync, 400);
  });
}
